import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  CertificateMonteCarloSimulation,
  CertificateRegression,
  DataEntityVolumeCertificateFormula
} from 'src/app/Interface/DataEntity/DataEntityVolumeForm_Interface';

interface MonteCarloRow {
  index: number;
  value: number | null;
  frequency: number | null;
}

@Component({
  selector: 'app-data-entity-volume-certificate-formula',
  templateUrl: './DataEntityVolumeCertificateFormula.component.html',
  styleUrls: ['./DataEntityVolumeCertificateFormula.component.scss']
})
export class DataEntityVolumeCertificateFormulaComponent implements OnChanges {
  @Input() formula: DataEntityVolumeCertificateFormula;
  @Input() formulaIndex = 0;
  @Input() initiallyExpanded = false;

  expanded = false;
  visibleMonteCarloRows: MonteCarloRow[] = [];
  monteCarloItemCount = 0;
  private visibleMonteCarloCount = 50;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initiallyExpanded && changes.initiallyExpanded.firstChange) {
      this.expanded = this.initiallyExpanded;
    }

    if (changes.formula) {
      this.visibleMonteCarloCount = 50;
      this.updateVisibleMonteCarloRows();
    }
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  showMoreMonteCarloData(): void {
    this.visibleMonteCarloCount += 50;
    this.updateVisibleMonteCarloRows();
  }

  formatCertificateValue(value: number | string | null | undefined): string {
    if (value === 'Infinity' || value === Number.POSITIVE_INFINITY) {
      return '∞';
    }

    return value === null || value === undefined || value === '' ? '—' : String(value);
  }

  getBooleanStatusLabel(value: boolean | null | undefined): string {
    if (value === true) {
      return 'قابل قبول';
    }

    if (value === false) {
      return 'غیرقابل قبول';
    }

    return 'محاسبه نشده';
  }

  getEnabledStatusLabel(value: boolean | null | undefined): string {
    if (value === true) {
      return 'فعال';
    }

    if (value === false) {
      return 'غیرفعال';
    }

    return 'نامشخص';
  }

  getStatusClass(value: boolean | null | undefined): string {
    return value === true ? 'certificate-status--accepted' : value === false ? 'certificate-status--rejected' : 'certificate-status--unknown';
  }

  hasRegression(regression: CertificateRegression | null): boolean {
    return regression !== null;
  }

  hasMonteCarlo(simulation: CertificateMonteCarloSimulation | null): boolean {
    return simulation !== null;
  }

  trackByParameter(index: number): number { return index; }
  trackByConstant(index: number): number { return index; }
  trackByMonteCarloValue(_index: number, row: MonteCarloRow): number { return row.index; }
  trackByIndex(index: number): number { return index; }

  private updateVisibleMonteCarloRows(): void {
    const simulation = this.formula && this.formula.monteCarloSimulation;
    const values = simulation ? simulation.values : [];
    const frequencies = simulation ? simulation.frequencies : [];
    this.monteCarloItemCount = Math.max(values.length, frequencies.length);
    const rowCount = Math.min(this.monteCarloItemCount, this.visibleMonteCarloCount);
    this.visibleMonteCarloRows = Array.from({ length: rowCount }, (_value, index) => ({
      index,
      value: index < values.length ? values[index] : null,
      frequency: index < frequencies.length ? frequencies[index] : null
    }));
  }
}
